import React from 'react'
import { NavLink  } from "react-router-dom"

export class Header extends React.Component {
    render(){
        return(
            <header id="header">
                <div className="container">
                    <div className="wrap xl-1">
                        <div className="col">
                            <ul>
                                <li><NavLink exact to="/" activeClassName="active">Home</NavLink></li>
                                <li><NavLink to="/about" activeClassName="active">About</NavLink></li>
                                <li><NavLink to="/contact" activeClassName="active">Contact</NavLink></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}